/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmissionRecord } from './submissionRecord';
import type { SubmissionReportPagination } from './submissionReportPagination';

/**
 * Submission report payload
 */
export interface SubmissionReport {
  /** Unique ID of the report type */
  reportId?: string;
  /** When the report was generated */
  createdAt?: string;
  data?: SubmissionRecord[];
  pagination?: SubmissionReportPagination;
}
